import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	constants,
	LocalStorageService,
	MappedContentItem,
	ParticipantUtilityService
} from '@edassist/common';
import { TimezonePipe } from '@edassist-ui/timezone';
import * as moment from 'moment-timezone';
import { ParticipantService } from '@edassist/api';
import { LoadingContainerService } from '@edassist/shared';

@Component({
	selector: 'ea-announcements',
	templateUrl: './announcement.component.html',
	styleUrls: [
		'./announcement.component.scss',
		'../notifications.component.scss'
	]
})
export class AnnouncementComponent implements OnInit {
	@Input() announcementContent: MappedContentItem;
	@Input() announcementRead = false;
	@Input() isAdminNotification = false;
	@Output() readonly markAsRead: EventEmitter<string> =
		new EventEmitter<string>();
	@Input() isHomePage: boolean;
	@Input() saveDismissTime = true;
	showAnnouncement: boolean;
	constants = constants;
	announcementTimeZone: string;
	maxBannerTextLength = 100;

	constructor(
		private readonly participantService: ParticipantService,
		private readonly loadingContainerService: LoadingContainerService,
		private readonly timezonePipe: TimezonePipe
	) {}

	ngOnInit(): void {
		this.showAnnouncement = true;
		this.announcementTimeZone = this.timezonePipe.transform(
			new Date(this.announcementContent.startDate),
			moment.tz.guess(),
			'z'
		);
		if (this.isHomePage) {
			this.maxBannerTextLength = 200;
		}
	}

	closeAnnouncementBanner(): void {
		this.showAnnouncement = false;
		if (this.saveDismissTime) {
			this.saveAnnouncementBannerDismissTime();
		}
		this.setShowStaticMessageBanner(this.showAnnouncement);
	}

	setShowStaticMessageBanner(showStaticMessageAnnoucement: boolean): void {
		LocalStorageService.setItem(
			constants.localStorageKeys.SHOW_STATIC_MESSAGE_ANNOUCEMENT,
			showStaticMessageAnnoucement
		);
	}

	onMarkAsRead(announcementId: string): void {
		this.markAsRead.emit(announcementId);
	}

	private saveAnnouncementBannerDismissTime(): void {
		const participantId = ParticipantUtilityService.getParticipantId();
		this.participantService
			.dismissBanner(participantId, this.constants.BANNER_TYPES.ANNOUNCEMENT)
			.subscribe();
	}
}
